// externals
import type { FC } from 'react';

// libraries
import { CheckBox } from '@interstate/components/CheckBox';

// interfaces/types
import type { CheckboxChangeEventHandlerChange, ColumnMapping } from '../manualAccessoriesTypes';

export type ManualAccessoryUpfrontFieldStateProps = {
    index: number;
    upFront: boolean;
    upfrontColumnMapping: ColumnMapping<boolean>;
    disabled: boolean;
    hasError?: boolean;
    errorMessage?: string;
};

export type ManualAccessoryUpfrontFieldDispatchProps = {
    handleCheckboxCheck: CheckboxChangeEventHandlerChange;
};

export type ManualAccessoryUpfrontFieldProps = ManualAccessoryUpfrontFieldDispatchProps & ManualAccessoryUpfrontFieldStateProps;

export const ManualAccessoryUpfrontField: FC<ManualAccessoryUpfrontFieldProps> = ({
    disabled,
    index,
    upFront,
    upfrontColumnMapping,
    handleCheckboxCheck
}) => (
    <CheckBox
        sx={{
            backgroundColor: 'inherit'
        }}
        label={upfrontColumnMapping.label}
        name={`${upfrontColumnMapping.fieldName}-${index}`}
        data-testid={`${upfrontColumnMapping.fieldName}-${index}`}
        onChange={(e) => {
            handleCheckboxCheck(e, upfrontColumnMapping.fieldName);
        }}
        checked={upFront}
        value={`${upfrontColumnMapping.fieldName}-${index}`}
        disabled={disabled}
    />
);
